import { getApiBaseUrl } from "./config"
const baseUrl = getApiBaseUrl();
const imgBaseUrl = `${baseUrl}/img`

const IMAGE = {
    ABOUT_HERO: {url: `${imgBaseUrl}/AboutPageImg.svg`, alt: "Young people having a conversation"},
    HOME_HERO_DESKTOP: {url: `${imgBaseUrl}/people-and-speech-bubble.svg`, alt: ""},
    HOME_HERO_MOBILE: {url: `${imgBaseUrl}/heroMobile.svg`, alt: ""},
    HOME_ICON_DEVICE: {url: `${imgBaseUrl}/MobileDeviceIcon.svg`, alt: ""},
    HOME_ICON_RIBBON: {url: `${imgBaseUrl}/RewardRibbonIcon.svg`, alt: ""},
    HOME_ICON_COMMENTS: {url: `${imgBaseUrl}/CommentsIcon.svg`, alt: ""},
    DECLINE_MODAL:{url: `${imgBaseUrl}/DeclineImg.svg`, alt: "Illustration of person using a computer and sharing their thoughts via a comments bubble with three dots"},
    ICON_BUBBLES:{url: `${imgBaseUrl}/Bubbles2.svg`, alt: "Colorful Bubbles"},
    NAVBAR_LOGO: {url: `${imgBaseUrl}/CoYESLogo2.svg`, alt: "Colorado Youth Experience Logo"},
    FOOTER_LOGO: {url: `${imgBaseUrl}/CDHSEmblemWhite.svg`, alt: "CDHS Emblem in white color"},
    CONGRATS_CONFETTI_MOBILE: {url: `${imgBaseUrl}/ConfettiMobile.svg`, alt: ""},
    CONGRATS_CONFETTI_DESKTOP: {url: `${imgBaseUrl}/ConfettiDesktop.svg`, alt: ""},
    ERROR_PAGE: {url: `${imgBaseUrl}/error-page-img.png`, alt: "A light blue bubble filled with question marks in a grey background"},
}

export default IMAGE